<template>
  <v-card
    outlined
    class="h100 card-height"
    style="color: color: rgba(0, 0, 0, 0.6);"
  >
    <v-card-title class="pb-0 pt-1">
      <a-plain-text-component>
        <strong>{{ fonction }}</strong>
      </a-plain-text-component>
      <v-spacer />
      <v-icon large>{{ icon }}</v-icon>
    </v-card-title>
    <v-card-text style="position: relative">
      <a-plain-text-div v-if="description">
        <a-plain-text-component>
          {{ description }}
        </a-plain-text-component>
      </a-plain-text-div>
      <template v-if="personnePhysique">
        <a-plain-text-div>
          <a-plain-text-component>
            {{ civilite | civilite }}
          </a-plain-text-component>
          <a-plain-text-component>
            {{ nom }}
          </a-plain-text-component>
          <a-plain-text-component>
            {{ prenom }}
          </a-plain-text-component>
        </a-plain-text-div>
        <a-plain-text-div v-if="comite && nationalite">
          Nationalité :&nbsp;
          <a-plain-text-component>
            {{ nationalite }}
          </a-plain-text-component>
        </a-plain-text-div>
      </template>
      <template v-if="personneMorale">
        <a-plain-text-div>
          <a-plain-text-component>
            {{ civilite | civilite }}
          </a-plain-text-component>
          <a-plain-text-component>
            {{ nomRepresentant }}
          </a-plain-text-component>
          <a-plain-text-component>
            {{ prenomRepresentant }}
          </a-plain-text-component>
          représentant la/le&nbsp;
          <a-plain-text-component>
            {{ formeJuridique }}
          </a-plain-text-component>
          <a-plain-text-component>
            {{ denomination }}
          </a-plain-text-component>
        </a-plain-text-div>
        <a-plain-text-div>
          N° d'inscription :&nbsp;
          <a-plain-text-component>
            {{ numeroInscription }}
          </a-plain-text-component>
        </a-plain-text-div>
      </template>
      <template v-if="adresse">
        <a-plain-text-div>
          <a-plain-text-component>
            {{ adresse.adresse }}
          </a-plain-text-component>
        </a-plain-text-div>
        <a-plain-text-div>
          <a-plain-text-component>
            {{ adresse.complementAdresse }}
          </a-plain-text-component>
        </a-plain-text-div>
        <a-plain-text-div>
          <a-plain-text-component>
            {{ adresse.codePostal }}
          </a-plain-text-component>
          <a-plain-text-component>
            {{ adresse.commune }}
          </a-plain-text-component>
          <a-plain-text-component>
            {{ adresse.pays }}
          </a-plain-text-component>
        </a-plain-text-div>
        <a-plain-text-div v-if="telephone">
          <a-plain-text-component>
            Téléphone :&nbsp;{{ telephone }}
          </a-plain-text-component>
        </a-plain-text-div>
        <a-plain-text-div v-if="email">
          <a-plain-text-component>
            Email :&nbsp;{{ email }}
          </a-plain-text-component>
        </a-plain-text-div>
      </template>
    </v-card-text>
  </v-card>
</template>

<script>
import mapPersonne from "./mapPersonne";
import makeValueData from "@/mixins/makeValueData";
export default {
  mixins: [makeValueData(mapPersonne)],
  props: {
    mode: {
      type: String,
      required: false,
    },
  },
  computed: {
    icon() {
      if (this.personneReprise) return "mdi-account-switch";
      if (this.personneMorale) return "mdi-account-group";
      return "mdi-account";
    },
    personnePhysique() {
      return "physique" === this.type;
    },
    personneMorale() {
      return "morale" === this.type;
    },
    personneReprise() {
      return "reprise" === this.type;
    },
    liquidation() {
      return "liquidateur" === this.mode;
    },
    comite() {
      return !this.liquidation;
    },
  },
};
</script>
<style scoped>
.card-height {
  min-height: 144px;
}
</style>


